/*
  SEARCH

    Get search result info for ALL TYPES.
 */
(function(window, document, undefined){

  function getSearchQueryParam(parameterKey) {
    var urlParams = new URLSearchParams(window.location.search);
    var queryParam = urlParams.get(parameterKey);

    return queryParam
  }

  function getSearchQueryResults() {
    var query = getSearchQueryParam('q');

    return fetch('/search?view=stats&q=' + query + '&options%5Bprefix%5D=last')
      .then(response => response.text())
      .then((data) => {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var queryInfo = JSON.parse(doc.getElementById('data').textContent);

        return queryInfo.shopQuery
      })
      .catch(error => console.warn(error));
  }

  function setSearchResultsFiltersTypeCount(argument) {
    getSearchQueryResults().then((response) => {
      var queryType = getSearchQueryParam('type');
      var urlParams = new URLSearchParams(window.location.search);
      console.log(queryType);
      console.log(urlParams);
      // console.log(queryType.split(',').length);
      // var queryTypeCount = queryType.split(',').length;

      if ( queryType != null && queryType.split(',').length < 3) {
        document.querySelector('#search-results-filter--product .result-type-count').childNodes[0].textContent = response.resultsProductCount;
        document.querySelector('#search-results-filter--page .result-type-count').childNodes[0].textContent = response.resultsPageCount;
        document.querySelector('#search-results-filter--article .result-type-count').childNodes[0].textContent = response.resultsArticleCount;
        document.querySelector('.result-type-count').classList.add('js-value-changed');
      }
    });
  }

  window.addEventListener('DOMContentLoaded', (event) => {
    setSearchResultsFiltersTypeCount();
  });
})(window, document);
